import * as React from 'react';
import c from 'classnames';
import styles from './Menu.css';
import { Link, useLocation } from 'react-router-dom';
import { currentActiveMenuLocation } from '../commons';

export const MenuItem = ({ text, path, external, ...restProps }) => {
  const activeMenuItem = currentActiveMenuLocation();
  const location = useLocation();
  const toppers = path === '/toppers' && activeMenuItem === 'toppers';
  const latest = path === '/latest' && activeMenuItem === 'nieuw';

  return (
    <>
      {external && (
        <a
          className={styles.navitem}
          href={path}
          rel="noopener noreferrer"
          target="_blank"
        >
          {text}
        </a>
      )}
      {!external && (
        <Link
          className={c(styles.navitem, {
            [styles.activeitem]: location.pathname === path || latest || toppers,
          })}
          to={path}
          {...restProps}
        >
          {text}
        </Link>
      )}
    </>
  );
};